import AnalyticsAPI from '@/api/analytics';

// actions
const actions = {
  async videoStart({ rootGetters }, payload) {
    if (!rootGetters['auth/isLogin']) return;
    try {
      await AnalyticsAPI.videoStart(payload);
    } catch (e) {
      throw e;
    }
  },
  async videoEnd({ rootGetters }, payload) {
    if (!rootGetters['auth/isLogin']) return;
    try {
      await AnalyticsAPI.videoEnd(payload);
    } catch (e) {
      throw e;
    }
  },
  async privilegeMovieStart({ rootGetters }, payload) {
    if (!rootGetters['auth/isLogin']) return;
    try {
      await AnalyticsAPI.privilegeMovieStart(payload);
    } catch (e) {
      throw e;
    }
  },
  async privilegeMovieEnd({ rootGetters }, payload) {
    if (!rootGetters['auth/isLogin']) return;
    try {
      await AnalyticsAPI.privilegeMovieEnd(payload);
    } catch (e) {
      throw e;
    }
  }
};


export default {
  namespaced: true,
  actions
};
